import styled from 'styled-components';

/**
 * The hero image, straight under the type heading the way the chat
 * announcement drew its menu panel: full width, softly rounded, capped so a
 * tall portrait upload cannot push the button off screen.
 */
export const HeroImage = styled.img`
  display: block;
  width: 100%;
  max-height: 440px;
  object-fit: cover;
  border-radius: 16px;
  margin-bottom: 24px;
  cursor: zoom-in;
`;

/**
 * The markdown body, styled here rather than left to the browser.
 *
 * The default h2 with its 0.83em margins looks nothing like the rest of the
 * app, and this exact block is also what the wizard's preview renders - so an
 * admin reading the preview is reading the same pixels a merchant will get.
 */
export const MarkdownBody = styled.div`
  color: ${({ theme }) => theme.darkGray};
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  margin-bottom: 24px;

  h1,
  h2,
  h3 {
    margin: 16px 0 8px;
    font-size: 16px;
    font-weight: 700;

    :first-child {
      margin-top: 0;
    }
  }

  p {
    margin: 0 0 12px;

    :last-child {
      margin-bottom: 0;
    }
  }

  ul,
  ol {
    margin: 0 0 12px;
    padding-left: 20px;
  }

  a {
    color: ${({ theme }) => theme.primary};
    text-decoration: underline;
  }

  img {
    max-width: 100%;
    border-radius: 8px;
  }
`;

/**
 * The quiet way out for a repeating announcement. Deliberately small and grey
 * next to the big red button: dismissing for good is the exception, and a
 * second full-weight button would make it read as an equal choice.
 */
export const DontShowAgain = styled.p`
  margin: 16px 0 0;
  text-align: center;
  font-size: 13px;
  color: ${({ theme }) => theme.lightGray};
  cursor: pointer;
  user-select: none;

  :hover {
    text-decoration: underline;
  }
`;
